import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { MonitorPlay } from "lucide-react";

export default function TvHome() {
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const saved = localStorage.getItem("carlitos_tv_code");
    if (saved) navigate(`/tv/${saved}`, { replace: true });
  }, [navigate]);

  const go = async (e) => {
    e.preventDefault();
    const c = code.trim().toUpperCase();
    if (c.length !== 6) return setError("El código tiene 6 caracteres");
    try {
      const r = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/tv/${c}`);
      if (!r.ok) throw new Error();
      localStorage.setItem("carlitos_tv_code", c);
      navigate(`/tv/${c}`);
    } catch {
      setError("Código no válido. Pídelo al administrador del ERP.");
    }
  };

  return (
    <main className="flex min-h-screen items-center justify-center bg-brand-navydark px-4" data-testid="tv-home">
      <form onSubmit={go} className="w-full max-w-md text-center">
        <MonitorPlay size={56} className="mx-auto text-brand-red" />
        <h1 className="mt-6 font-script text-5xl font-bold text-white">Carlito's <span className="text-brand-red">TV</span></h1>
        <p className="mt-2 text-sm text-white/60">Escribe el código de 6 letras que aparece en Proyectar (sección Pantallas)</p>
        <input
          data-testid="tv-code-input"
          value={code}
          onChange={(e) => { setCode(e.target.value.toUpperCase()); setError(""); }}
          maxLength={6}
          placeholder="ABC123"
          className="mt-8 w-full rounded-2xl border-2 border-white/20 bg-white/10 px-6 py-5 text-center font-heading text-4xl font-extrabold uppercase tracking-[0.4em] text-white placeholder:text-white/20 focus:border-brand-red focus:outline-none"
        />
        {error && <p className="mt-3 text-sm font-semibold text-brand-red" data-testid="tv-code-error">{error}</p>}
        <button data-testid="tv-code-submit" className="mt-6 w-full rounded-full bg-brand-red py-4 font-heading text-lg font-bold text-white transition-transform hover:scale-95">
          Conectar esta pantalla
        </button>
      </form>
    </main>
  );
}
